module.exports = ".likesWrapper {\n  height: 330px;\n  overflow: auto;\n}\n\n.circle-img-placeholder-mini {\n  height: 50px;\n  width: 50px;\n}\n\n.show-more {\n  position: absolute;\n  bottom: 10px;\n  left: 0px;\n  right: 0px;\n}\n\n.show-more span.text11 {\n  padding: 5px 10px;\n  background: #fc6b6a;\n  color: #fff;\n  border-radius: 50px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/likes/likes.component.css
// module id = ./src/app/shared/components/likes/likes.component.css
// module chunks = main